<template>
  <div class="" ref="llm">

    <div v-html="msg"></div>
    <el-button type="primary" @click="llmStart">llmStart</el-button>
    <el-button type="primary" @click="llmStop">llmStop</el-button>
    <el-button type="primary" @click="log">log</el-button>
    <el-button type="primary" @click="message">message</el-button>
    <el-button type="primary" @click="sendTips">sendTips</el-button>
    <el-button type="primary" @click="handleConfirm">handleConfirm</el-button>

    <!-- dialog -->
    <el-button @click="loginForYD">移动一键登录标准版H5</el-button>
    <el-button @click="handleOpenZhiling">打开弹窗</el-button>

        <el-dialog
          ref="myDialog"
          title="弹窗标题"
          :visible.sync="dialogVisible"
          width="40%"
          custom-class="custom-dialog"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          @close="handleClose"
        >
          <div class="dialog-content">
            <div class="main-content">
              <el-button type="primary" @click="$refs.myZhilingPanel.handleOpen();">
                打开右侧面板
              </el-button>

              <ZhilingOpen />
              <el-input type="textarea" ref="myTextarea" v-model="text"></el-input>
            </div>
            <el-select style="width: 6rem;" class="custom-select"
                  v-model="text"
                  filterable
                  size="mini"
                  placeholder="分组">
                <el-option
                  :label="'a'"
                  :key="'1'"
                  :value="'2'"
                />
            </el-select>
            <el-button @click="checkTextContains('XXX')">检查是否包含内容</el-button>
            <el-button @click="insertText('XXXXX')">插入文本</el-button>
          </div>
        </el-dialog>

        <!-- dialog-end -->


    <!-- <LlmSkeleton /> -->
    <ZhilingSelect v-show="showZhilingPanelFlag" ref="myZhilingPanel"/>


  </div>
</template>
<script>
import VConsole from 'vconsole';
import sse from '@/utils/llmstream'
import { create } from '@/api/statlog'
import LlmSkeleton from '@/components/LlmSkeleton'
import { EventBus } from '@/utils/eventbus';
import ZhilingSelect from '@/components/zhiling/zhiling-select';
import ZhilingOpen from '@/components/zhiling/zhiling-open';
import * as LoginApi from '@/api/auth'
import * as EnumApi from '@/api/enums'
import * as ImmessageApi from '@/api/immessage'
import { mapState, mapMutations} from 'vuex'
export default {
  components: {
    LlmSkeleton,ZhilingSelect,ZhilingOpen
  },
  data() {
    return {
      msg: '',
      width: 0,
      height: 0,
      top: 0,
      left: 0,
      showModal: false,
      dialogVisible: false,
      text: "",
      cursorPosition: 0,
      enums: {},
    }
  },
  computed: {
  	...mapState(['showZhilingPanelFlag']),
  },
  mounted() {
    const vConsole = new VConsole();
    this.handleEnum()
  },
  methods: {
    ...mapMutations(['setEnums', 'setStoryContents',
     'setDialogShowCostomContactFlag', 'setShowZhilingPanelFlag']),
    handleConfirm(){
      let text = `
1
场景 ：内院柴房​
*我准备烧毁一个旧木匣，弹幕说匣子里装着父亲留下的珍贵书信。萧云昭在旁催我快烧，说那是没用的东西。我本来想看看，可看他神色奇怪，就将匣子丢向柴堆。​
*萧云昭离开后，我赶忙从还没燃烧的柴堆里翻出木匣。打开一看，果然是父亲留给我的书信，还有一块羊脂玉佩，我心里特别不是滋味，小心的将玉佩藏好。​
*我从柴房走出来，无意间听到萧云昭与婆婆的对话。他们谈论着我烧匣子的事，萧云昭打算带柳如烟去京城，让我留下在家中伺候婆婆。​
*弹幕评论这是本虐心话本，说男主最后会回头求复合。我心若死灰，最后选择相信弹幕上的说法，明白自己在萧云昭心里只是奴仆。​
*萧云昭见我进来，冷淡地问我还有多少银子，说要帮助柳如烟。我一反常态说没钱，他露出嘲讽神情，提醒我亏欠了柳如烟。​

钩子：我的心猛然一颤，我父亲是大善人，当初土匪抢劫先救了离自己更近的萧云昭，没来得及救下刘小梅的父亲。 而我父亲救了周荣宗后，因为跑的慢被土匪砍了一刀，再也没有醒过来。

写作技巧：​
*借弹幕与现实情节交融，巧妙点明故事走向，增强读者代入感与紧张感。​
*用我偷偷找回玉佩的举动，和萧云昭的算计形成鲜明反差，凸显人物性格。​
*借回忆父亲当年仗义助人之事，深化人物关系，为后续情节埋下伏笔。​
*描绘我内心从迟疑到绝望的变化，展现人物情感转变，增强情节戏剧性。


2
场景 ：大厅
*柳如烟突然出现，哭诉家里出了变故，马上要活不下去了。她的样子楚楚可怜，梨花带雨的姿态令人动容。
*我质问萧云昭，当年父亲救了她的命，他如今这样做，心中是否愧疚。萧云昭却冷笑，说自己本来就能逃走，暗指父亲救他是因我钟情于他。
*萧云昭的话像利刃一样刺痛我的心，我非常愤怒，但一时说不出话来。柳如烟假装劝说萧云昭，还说我或许是琐事太多，心里烦乱。。
*萧云昭对我视若无睹，当即承诺会为柳如烟排忧解难。柳如烟顺势邀请萧云昭去她家坐坐，尝尝家中新做的糕点。
*萧云昭与柳如烟一起走了，二人的背影看上去非常亲昵。我回忆过去，我常让萧云昭对柳家施以援手。
场景：卧房
*萧母来劝慰我，说萧云昭口不择言，让我多迁就他些，还说女子只有柔顺，才能让夫婿喜欢。
*我不禁回想起父亲死后，萧母曾在众人面前信誓旦旦，要将我当作亲生女儿，还定下我与萧云昭的婚约。
*此刻我才看清，萧母实则口蜜腹剑，明知其子居心不良，竟还妄想将我推进火坑。我下定主意，打算明日就去城中，购置前往京城的车马等物事。
*脑海中弹幕纷飞，众人议论纷纷，猜测我去京城后，萧云昭将如何纠缠，又会不会撞见他与柳如烟苟且之事。
*我暗自冷笑，我一定不会让萧云昭有机会搅乱我的前程。

钩子：我笑了笑，萧云昭还想去京城？ 没门。

写作技巧：
*借柳如烟与萧云昭的暧昧互动，以及萧母的虚假说辞，展现主角深陷复杂困境，孤立无援的处境。
*穿插回忆往昔，对比当下，凸显人物关系巨变，强化主角内心的失望与愤懑。
*融入弹幕元素，增添新奇感与互动性，巧妙暗示故事走向。
*借主角内心想法与实际行动，展现其从懵懂认命到果断反抗的蜕变，为后续情节发展埋下伏笔。


3​
场景 ：大厅
*我回到府中，还没进房间，就听到里头传来阵阵笑声。走近一看，柳如烟与萧云昭正亲昵地相对而坐，相互递着糕点，看起来像夫妻一样。萧母瞧见我，刹那间，屋内的气氛凝固起来。​
*我对他们视若不见，直接走向自己屋里。不一会儿，外头又热闹起来，全是柳如烟对京城繁华的憧憬，还有萧云昭的附和。​
*我开始整理东西，突然发现床头柜子里的木匣位置变了。打开一瞧，里面装着的父亲留给我的玉佩竟没了，我很着急，四处翻找。​
*脑海中弹幕闪现，提示玉佩被萧云昭送给了柳如烟，我瞬间怒发冲冠，疾步冲出房间，当面质问萧云昭。​
*柳如烟一脸得意地承认萧云昭将玉佩送给了她。我怒不可遏，质问萧云昭为什么擅自处置我的珍贵之物，同时回忆起玉佩承载的往昔与重要意义。​

钩子：「不就是个破玉佩，以后让云昭给你买个新的。」

写作技巧：​
*通过对比我回府前后的氛围变化，凸显我在这段关系以及这个家中的孤立与被排挤之感。​
*运用回忆手法，阐明玉佩对我的特殊意义，加深情感冲突的激烈程度。​
*借助弹幕的设置，提前透露部分情节走向，提升读者的期待值。​
*细腻描绘我的情绪起伏，从平静到暴怒，使读者更易产生共鸣，增强代入感。


4​
场景 ：正厅​
*我使劲儿挣脱萧母的拉扯，当面问萧云昭，愿不愿意把我爹留下的玉佩还给我。萧云昭神色闪躲，想糊弄过去，我见状，一把抓起桌上供奉的萧家祖宗排位，做出要砸的样子，萧云昭一下子变了脸色。​
*萧云昭大声骂我不知礼数，做事荒唐，后悔跟我定下婚约。我沉着脸索要玉佩，柳如烟很不情愿地从袖中掏出，还偷偷使坏，暗掐玉佩边缘，好像要弄坏它。​
*我警告她要玉佩坏了，就拿萧家祖宗牌位陪葬，我顺利拿回完好的玉佩。柳如烟气得眼睛都红了，她匆匆离去，萧云昭赶紧追了出去。​
*萧母在一旁破口大骂，指责我嫁入萧家后太嚣张，我没理会，转身回房间。​
场景 ：卧室​
*我在房里，紧握着手中通往京城的通关文书，心想着马上离开这是非之地，可想到城外山路崎岖，夜间行走危险重重，只能暂时作罢。​
*萧云昭突然端着羹汤走进来，一眼瞥见桌上的通关文书。他面露欣喜，以为是我为他准备的，让我再弄一份，好带柳如烟一起去京城。​
*萧云昭还假惺惺解释，柳如烟只是自家表妹，带她去京城是为了给她看病。我无意间看见他衣领上有红色胭脂，心里就明白了，冷笑一声，说愿意帮助她。​
*我心里琢磨，要是萧云昭能承认喜欢柳如烟，我就告诉他，这次去京城他有灾祸，只是因为当年我父亲牺牲了自己救了他的命，才不愿让他冒冒失失去京城。​

钩子：毕竟他的命是我爹救的，我还没想对他赶尽杀绝。

写作技巧：​
*通过我威胁砸毁祖宗排位的举动，凸显我的果敢强硬，将冲突推向高潮。​
*借萧云昭衣领上的胭脂印这一细节，暗示他与柳如烟的不正当关系，增添情节紧张感。​
*借我的内心独白，披露父亲对萧云昭有救命之恩的过往，为故事埋下更多伏笔。​
*对比我面对纷争时的沉稳与萧云昭的慌乱，鲜明展现人物性格差异。​


5​
场景 ：卧房​
*我说爹以前救了萧云昭的命，萧云昭的脸色一下子变得很难看，可他还强装镇定，拍着胸脯保证一定会记住这份恩情，好好照顾我。我在心中偷偷冷笑，回想起前世被他算计，下场凄惨，暗暗发誓，这辈子绝不再像之前那样愚蠢。​
*萧云昭话锋一转，说明日萧府要大摆宴席，宴请城中权贵，以此彰显萧府财力，实际上就是暗示我得出钱帮忙。我心中明白他的算计，却没说什么，主动提出愿拿出自己的体己钱，助他办好这场宴席，还说可多给他些银钱，好让他与柳如烟在日后花销上更为宽裕，这般善解人意的模样，让萧云昭有些始料未及。​
*萧云昭见我如此 “懂事”，心中得意，便想伸手摸摸我的头，以示亲昵。我心中厌恶，却巧妙侧身躲开，佯装羞涩地说道，如今尚未正式拜堂成亲，这般亲昵举动不合礼数，待日后行过大礼，再亲近也不迟。​
*我敏锐地捕捉到萧云昭眼中一闪而过的愧疚，心中更加笃定，他定是打着成亲后便将我弃之不顾的算盘。我佯装未察觉，寻了个借口，将萧云昭请出了房间。​
*我在房内暗自下定决心，这一世，我定要摆脱被萧云昭掌控的悲惨命运，不再做任人宰割的弱女子。我要凭借自己的聪慧与果敢，经商致富，甚至要在这男尊女卑的世道里，闯出一片属于自己的天地，为自己，也为家族争得荣耀。​

钩子：我假装没看到萧云昭眼中一闪而过的愧疚，将他赶出了房间。

写作技巧：​
*借助回忆前世悲惨遭遇，迅速交代故事背景，凸显梦书瑶重生后的心理转变，形成强烈对比。​
*通过梦书瑶内心所想与外在表现的差异，展现她的聪慧与坚毅，同时为后续剧情发展埋下伏笔。​
*从萧云昭的言行细节，像暗示要钱、试图亲昵举动等，刻画其贪婪、虚伪的性格，引发读者对他的反感。​
*在梦书瑶的内心独白中巧妙埋下伏笔，如立志经商致富、闯出一片天等，暗示她未来的发展方向。


6​
场景 ：大厅
*婆婆一早就买了好多吃的，为萧云昭践行。我早上告诉婆婆，我能从店里赊到酒菜，婆母对我一下子就热情起来。​
*府里婆子丫鬟们准备吃的，闲聊的时候婆婆说我要干活挣钱，好送给萧云昭。大家都讨好婆婆，说她好福气。​
*我背着包袱要走了，关门的时候心里偷偷骂婆婆。婆婆发现我跑了，气得在房里拍桌子。​
场景 ：城中首饰铺​
*我路过首饰铺，听到萧云昭与柳如烟的声音。萧云昭正为柳如烟试戴一支绿色的玉簪子，二人动作亲密。​
*我走过去，萧云昭发现我，簪子掉在地上碎了，我劝萧云昭买下来。萧云昭说这是送给柳如烟生辰的贺礼。​
*柳如烟很得意，说今日府中的宴席就是为她生辰办的。我看他们穿着漂亮的衣服，再看自己的粗布衣服，差别太大了。​
*萧云昭警告我不要与柳如烟攀比，还说宴席也是为他们二人饯行的。我假装听话的点头，让萧云昭特别惊讶。​

钩子：我却摆了摆手：「提前恭贺你们了。」

写作技巧：​
*借婆婆与众人对话，展露我在萧府的低微地位，唤起读者怜悯。​
*对比萧云昭对柳如烟与我的态度，凸显情感不均，激化矛盾冲突。​
*以我的内心想法呈现心理转变，从愤懑到冷静，暗示将有谋划，增添故事悬念。​
*通过服饰等细节对比，彰显人物差距，加深矛盾。


7​
场景 ：城中首饰铺
*我正要离开，萧云昭一把拉住我，他看见我的大包袱，觉得奇怪。我骗他说是写给远方姨母的旧衣服，柳如烟笑话我，讥讽我 “贤良”。萧云昭赶忙哄着柳如烟，还说我没见识。​
*萧云昭嘱咐我，别早安排车马，因为柳如烟喜睡懒觉。我乖乖点头，萧云昭更意外了。他假装好心的说以后会来接我，又要我好好照顾婆婆。​
*柳如烟满脸嫉妒，提醒萧云昭之前约好一起去吃茶点。萧云昭又对我说会带点心给我，这话让我想起以前他多次食言。我笑着跟他们告别，心中都是对京城新生活的期待。​
场景 ：城郊集市​
*在城郊集市，我找到刘媒婆，将祖宅低价转卖给她。刘媒婆有点不好意思，我悄悄说萧家人可能会闹事。刘媒婆拍着胸脯保证，有法子撵走萧氏母子，然后祝我一路顺遂。​
*我上了去京城的马车，通过神器弹幕，知到萧府现在乱成一锅粥。​

钩子：弹幕一直在刷屏，我拼凑出在老家发生的闹剧。​

写作技巧：​
*借人物对话与内心想法，展现萧云昭的伪善、柳如烟的善妒，以及我的隐忍与决然。​
*借回忆萧云昭过往食言之事，丰富情节，加深人物矛盾。​
*通过与刘媒婆的交谈，暗示我的筹谋及后续可能引发的冲突，增添故事张力。​
*运用神器弹幕这一独特元素，凸显主角穿书的特殊身份，为故事注入新看点。

8​
场景 ：大厅
*萧云昭和柳如烟带着礼品回到萧府，府中的饯行宴正式开始。好吃的刚摆上桌，家丁便呈上一封从京城寄来的加急信件。萧云昭欢喜地拆开，却发现他谋求京城差事被拒绝。​
*萧云昭站着呆住了，反复翻看不敢相信，他抓住家丁问为什么，可家丁也不清楚。府中宾客得知了，态度马上转变，开始嘲笑萧家。​
*之前借过钱给萧母的亲戚，当场就让萧母还钱，毕竟宴上酒菜都是赊来到。一个远房亲戚甚至抢走了柳如烟头上的金钗，叫嚷着抵债。宴席瞬间乱作一团，不欢而散。​
*萧母气得脸色发白，怪我不在府里。萧云昭也急的不行，希望我能快点回来帮忙，好重新找个京城的差事，也赔给柳如烟丢失的金钗。​
*萧云昭差人去我姨母家询问我去哪了，姨母说不清楚。晚上，刘媒婆带着几个壮汉收房，萧氏母子这才知道祖宅已换了主人。​
场景 ：府门口
*刘媒婆将萧家母子的东西扔到街上，关了大门。萧云昭没办法，只能带着萧母暂时住在柳家，他们原来的老宅早就破的不能住了。​
*萧云昭特别恨我，怪我没能帮他在京城找到差事，又气我偷偷卖了房子。他假装镇定安慰母亲，说我可能是想带他们住更好的地方。​
*婆婆因丢了面子气的不行，说等我回来一定要处置我，还说要是有新房子，必须拿到房契。萧云昭向母亲保证一定照做。​
*萧云昭站在府门口，望着我姨母家方向，看见姨母家表弟路过，满心期待地张望，却没我的影子。他心中不安。​

钩子：他站在村口，远远地看到我姨家表弟朝他走过来，他期盼地朝他身后张望，却始终没有我的身影。

写作技巧：​
*借萧云昭收到拒信场景，制造从期望到绝望的强烈情感落差，凸显其困境。​
*描绘宾客态度骤变，尽显世态炎凉，增添剧情戏剧性与冲突感。​
*通过萧母和萧云昭的对话及心理，暴露他们对我的依赖与期待，也展现出其自私短视。​
*祖宅被收情节，进一步加剧主角困境，提升故事紧张度与矛盾冲突。​
*结尾萧云昭的期待与失落，既呼应开头，又为后续章节设下伏笔，维持故事连贯性与悬念感。


9​
场景 ：京城的小院​
*我在京城找到一个安静小院，专心研究做生意，为以后在京城站稳脚跟做准备。神器弹幕提示我，这些本事将成为我在这异世安身立命的关键，我每天努力学习，日子过得简单却充实。​
*想象以前在萧家受的气，我更确定提升自己最重要，比不靠谱的男人强多了。我知道，有了真本事就什么都不怕，而人心易变，不能轻信。​
*某一天，弹幕突然警示，萧云昭要来京城纠缠我。我心中一紧，暗自做好应对准备，不能像以前一样被欺负。​
场景 ：京城集市​
*在热闹的京城集市，我碰到了一脸疲惫的萧云昭。他看见我竟摆出一副高高在上的姿态，让我随他回云城。​
*萧云昭要与我重修旧好，还想让我回去伺候婆婆。我心中一阵厌恶，这才发现他依旧把我当做可以随意摆弄的人。​
*我拿出账本证质问他，是不是在他心里，所谓的 财富 比我本身还重要？他一下愣住，语气变软，开始假惺惺道歉。​
*萧云昭又说，我可留在京城，但要帮扶柳如烟。这话把我惹怒了，以前他与柳如烟算计我、背叛问的事都涌上心头。​
*我怒目圆睁，大步朝着萧云昭走过去。我看见他眼睛里有期待，还张开了双臂，像是等我 “回心转意”。我心中五味杂陈，脚下步伐却未停歇。​

钩子：我快步跑到萧云昭跟前，看着他的瞳孔逐渐放大，隐隐带着期待。他甚至张开双臂，想来拥抱我。

写作技巧：​
*借助神器弹幕这一特殊元素，巧妙引导读者情绪，增强故事互动感与代入感。​
*对比我在小院中的宁静生活与集市上遇萧云昭后的愤怒情绪，凸显矛盾冲突。​
*通过萧云昭的言行举止，生动勾勒出他自私自利、贪婪无度的形象，引发读者反感。​
*运用回忆手法，简略回溯萧云昭过往恶行，加深矛盾根源。​
*结尾通过我的行动和萧云昭的反应，营造强烈悬念，紧紧抓住读者好奇心。


10​
场景 ：城郊小道​
*我气的不行，抬手狠狠甩了萧云昭三个巴掌，又拿起路边木棍，朝着他的头和身子猛抽。我骂萧云昭狼心狗肺， 萧云昭一脸震惊，可很快便恢复平静，还笑着让我继续打。​
*弹幕纷飞，都是对萧云昭此举的愤怒与无奈。我瞧见路边一坨秽物，恶从心头起，捡起就往他脸上糊，这下终于让他破了功，弯腰干呕起来。​
*我冷冷说，他打着弥补的幌子，实际上却和柳如烟暗中苟且，既想把我困在萧家当牛做马，又想与那表妹逍遥快活。我让他滚。
*萧云昭灰溜溜逃走后，我的日子有恢复安宁。弹幕偶尔传来萧云昭与柳如烟的消息，什么他俩和萧母起了争执，柳如烟将萧家母子扫地出门之类事情。​
*我平静地看着这些消息，以前怨恨早就没了，只想着以后怎么做。可没想到，萧云昭竟又来京城了。​

钩子：可是萧云昭又来了京城，我以为他是因为不甘心，来追随刘小梅的。​

写作技巧：​
*借助激烈的动作与言语冲突，凸显我对萧云昭的满腔恨意，带动读者情绪。​
*以弹幕充当旁白，增添故事互动性与新奇感，同时展现旁人对事态的看法。​
*刻画我情绪由愤怒转向平静的过程，体现人物的蜕变与心境成长。​
*借弹幕透露信息，简洁勾勒萧云昭与柳如烟后续状况，免去冗长叙述。​
*末句设下悬念，引发读者对萧云昭再度现身缘由的猜测，为后续章节铺垫。


11​
场景 ：京城小院外​
*萧云昭近来总在我的小院外晃悠，还求我府上小厮给我送各种点心，其中还有我从前最爱吃的桂花糕。他逢人便说他是我的未婚夫婿，一时间，街头巷尾流言纷纷，都说他痴情。​
场景 ：小院花园​
*我被烦的不行，我只好答应与萧云昭见面。我冷着脸，说与他再无瓜葛，话语里都是嫌恶。萧云昭红着眼眶，哭着向我道歉，说当年是我父亲的去世太过悲痛，才逃避我，求我饶恕。​
*我脑海中想起幼时与萧云昭相处的画面，可很快便回过神来，我明白，绝不会再重蹈覆辙。我嘲讽地看向他，问他这次来是不是在外头混不下去，没了依靠才想起我。​
*萧云昭竟厚着脸皮说想与我重归于好，我觉得恶心，不想多说，一甩袖子走了。​
场景 ：京城酒楼​
*在酒楼谈生意时，我认识了秦书怀，他是我父亲故交的儿子，也是商人。此后，我们常一同探讨经史子集，还结伴游览京城古迹，交流各自见解。​
*秦书怀为人爽朗，学识极为渊博，总能与我分享诸多新奇趣事，一来二去，我们相处得十分融洽。​
场景 ：京城酒楼​
*一日，我与秦书谈生意，在酒楼小聚。正吃得高兴，萧云昭却突然闯了进来，他双眼通红，指着我，怒声质问我是不是看上了别人，所以才坚决不肯与他复合。​
场景 ：梦书瑶的内心世界​
*我心中暗自骂萧云昭，同时弹幕也纷纷弹出，都是对萧云昭行为的不齿。我愈发确定，萧云昭是失了势才纠缠不休，我不会再心软回头。​

钩子：有次我们在新商铺谈合作，周荣宗不知从哪里跑出来，他指着我，双眼猩红：「梦书瑶，这就是你不愿意和我复合的原因？你喜欢上了别人。」

写作技巧：​
*借回忆片段呈现我与萧云昭的过往，丰富人物背景。​
*以弹幕形式插入旁人评论，增添叙事的层次与新奇感。​
*将萧云昭的死缠烂打与秦书怀的温和友善相对比，凸显两种关系的差别，暗示情感发展走向。​
*通过我的内心想法及对萧云昭言行的描述，塑造出一个理智清醒的女主形象，与萧云昭的冲动形成鲜明反差。

12​
场景 ：京城小院外​
*萧云昭突然出现在我的小院外晃悠，让人觉得奇怪。之前他天天在我小院外纠缠我的事，已在京城传开，现在他憔悴落魄、形容枯槁，与书院里年轻学子们的意气风发形成了强烈反差。​
*秦书怀见萧云昭这样，想上前为我解围，却被我抬手拦下。周围邻居交头接耳，小声议论，有人觉得我既已来京城发展，便不应再与他牵扯，也有人竟还觉得萧云昭一片痴心，实在可怜。​
*萧云昭一脸恳切，提议与我重提婚约，说要留在京城伴我。我心中冷笑，毫不留情地说起他曾妄图毁我名声，让我只能委身于他的事。听我这么说，萧云昭瞬间变了脸色，恼羞成怒地质问我，难道就从来没真心喜欢过他。​
*邻居们听说萧云昭的恶行，都站我这边，对他一脸嫌弃。萧云昭受不了指指点点，灰溜溜地逃走了。​
*弹幕适时弹出，原来萧云昭竟认为是自己失了钱财，落魄了，我才嫌弃他，现在他正想着去找柳如烟，从她那儿捞些好处。​
场景 ：京城闹市街头​
*我远远瞧见萧云昭追着柳如烟要钱。再看柳如烟，打扮得花枝招展，身旁还有一位富家公子。​
*萧云昭扯着嗓子，说柳如烟欠他许多钱，今日必须归还。柳如烟却笑话他，说当初那些银钱都是他心甘情愿给的，哪有要回的道理。​
*柳如烟身旁的富家公子也跟着起哄，随手掏出一锭碎银扔在地上，满脸不屑，使劲儿羞辱萧云昭。萧云昭哪里受过这样的侮辱，脸一下通红。​

钩子：萧云昭何时受过这种侮辱, 脸涨得通红。

写作技巧：​
*通过对比萧云昭与书院学子们的状态，突出他的落魄与格格不入。​
*借学子们的议论和态度转变，侧面反映出京城众人对婚姻、声誉等的看法，增添故事的真实感。​
*通过我对萧云昭的冷漠态度，以及直接揭露他的恶劣行径，彰显我的果敢与坚决。​
*运用弹幕提示的手法，自然地引出下一个场景，保证故事流畅连贯。​
*在闹市街头场景中，借柳如烟和富家公子的言行，将萧云昭的可怜与可笑展露无遗，加深读者对他的负面印象。


13​
场景 ：京城医馆外​
*街上人来人往，萧云昭远远看见了我，脸一下子红了，不好意思的地低下了头。这一动作能看出他后悔以前那样对我。
场景 ：城郊小河边​
*几天后，萧云昭不见了。原来是柳如烟约他晚上去城郊小河边见面，说是要给他一笔钱。可到了地方，萧云昭竟不小心跌入河里。柳如烟看他掉下去额也没喊人救命，等到旁人发现的时候，萧云昭都快没气了，柳如烟的心真狠啊。​
场景 ：京兆尹衙门​
*京兆尹问柳如烟事情经过，柳如烟说她知道萧云昭会水，所以没叫人，这话听起来好像有道理。可仔细想想，就觉得她心里有坏主意。​
场景 ：医馆病房​
*萧云昭被救后，身体特别差，他希望见我一面。我走到他床边，他嘴唇颤抖，好不容易说出 “对不起” 三个字。我凑近看，能清晰地看到他眼中到悔恨和哀求，可我早就下定决心，绝不心软，直接转身就走。
场景 ：现实世界（此处仍保留穿书设定中的特殊场景概念）​
*我对着神器弹幕致谢，多亏它们一路提醒，我摆脱了原本悲惨的命运，没成为那苦情戏中的可怜女主。弹幕先是一阵闪烁，好像是对我的举动感到诧异，随后渐渐消失。这时，秦书怀来了，邀我一同去享用晚宴，我的新生活开始了。​

钩子：我回头，是秦书怀灿烂的笑脸。​

写作技巧：​
*借萧云昭的遭遇以及柳如烟的恶劣行径，生动诠释了善恶有报的主题，让读者心中的正义感得以伸张。​
*巧妙借助弹幕互动，打破常规叙事界限，增添故事的新奇感与趣味性，贴合穿书设定的独特风格。​
*通过展现我对萧云昭态度的转变，凸显我从任人摆布到自主掌控人生的蜕变，彰显女性自我意识的觉醒。​
*凭借简洁的对话以及细腻的细节刻画，比如萧云昭的神情与动作，精准传递出人物内心复杂的情感变化。`
      let handelText = this.$validateTitle(text)
      const storyOutlinesPrue=this.$parseContent(text)
      console.log('ecloudSign ', handelText, storyOutlinesPrue)
    },
    async loginForYD() {
      const res = await LoginApi.ecloudSign({ appid: '300012963603', urlquery: localStorage.urlquery })
      let result = res.data
      if (result.code === 0) {
        let appId = result.data.appId
        let traceId = result.data.traceId
        let sign = result.data.sign
        let version = result.data.version
        let timestamp = result.data.timestamp
        console.log('ecloudSign ', result)
        YDRZAuthLogin.getTokenInfo({
        	data: { //请求的参数
        		version: version, //接口版本号 （必填）
        		appId: appId, //应用Id （必填）
        		sign: sign, //加密后的sign（必填）。sign生成规则： MD5(appId + businessType + msgId + timestamp + traceId + version + appkey)	注： msgID要和traceID保持一致， 此处sign与token校验接口sign的生成规则不同
        		traceId: traceId, //业务方生成唯一标识
        		timestamp: timestamp, //请求消息发送的系统时间，精确到毫秒，共17位，格式：20121227180001165
        		openType: '1', //取号类型
        		expandParams: '', //扩展参数 格式：参数名=值 多个时使用 \| 分割 （选填）
        		authPageType: '0', //若值为“1”时展示弹窗，若值为“2”时展示自定义弹窗版，若值为“3”时展示自定义页面版，若为其它值则展示页面
        	},
        	//成功回调
        	success: function(res) {
            console.log('success ', res);
            // alert('success：'+JSON.stringify(res))
            let msgId = res.msgId
            let token = res.token
            let userInformation = res.userInformation
            LoginApi.ecloudPhone({ appid: appId, token, msgId, userInformation }).then((res2)=>{
              alert(JSON.stringify(res2));
            })
          },
        	//错误回调
        	error: function(res) {console.log('error ', res);alert(JSON.stringify(res))},
        	//authPageType等于2时可以通过该回调方法监听，用户输入中间四位号码并勾选协议后触发
        	layerCallback: function(res) {
            console.log('layerCallback ', res);
          }
        })
      }
    },
    handleEnum() {
      EnumApi.list().then(res => {
        let result = res.data.data;
        this.setEnums(result)
      })
    },
    handleOpenZhiling(){
      this.dialogVisible = true
    },
    handleClose() {

    },
    llmStart() {
      //1806516321777786881 标题
      //1784807018246393858 工作流002
      //1792808128543162370 知识图谱
      let storyText = `
Elon Musk 是 Tesla 和 SpaceX 的创始人。他在 2004 年加入 Tesla，并在 2008 年成为 CEO。
SpaceX 在 2002 年由 Musk 创立，目标是将人类送往火星。
`
      sse("1792808128543162370", {articleId: '1856219105523118081', storyOutlineNumber: 4, storyText: storyText}, this.handleMsg).then((result)=>{
        console.log('result', result);
      })
    },
    llmStop() {
      let processInstanceId = localStorage.getItem('processInstanceId')
      let queueName = localStorage.getItem('queueName')
      console.log('processInstanceId', processInstanceId);
      console.log('queueName', queueName);
      if((processInstanceId && processInstanceId.length > 0) && (queueName && queueName.length > 0)){
        ImmessageApi.llmStop({ processInstanceId, queueName }).then(res => {
          console.log('llmStop', res);
        })
      }
    },
    sendTips(){
      let tips = ''
      // 60s、提示用户：糟糕！脑电波链接失败！被神秘信号干扰，请尝试重新生成，或稍后重试！
      // 50S、提示用户：码哩码哩哄～(╯‵□′)╯︵┻━┻（持续念咒中···）
      // 40S、提示用户：码哩码哩哄～(╯°□°）╯︵ ┻━┻（念咒中···）
      // 30S、提示用户：共脑中(●--●)···
      // 20S、提示用户：码哩正在读取你的想法(●°u°●)​ 」···
      // 10S、提示用户：码哩正在打开脑电波，接受信号中O(∩_∩)O~···
      const duration = Math.floor(Math.random() * 6);
      console.log('duration',duration);
      if(duration == 5){
        tips = '糟糕！脑电波链接失败！被神秘信号干扰，请尝试重新生成，或稍后重试！'
      }else if(duration == 4){
        tips = '码哩码哩哄～(╯‵□′)╯︵┻━┻（持续念咒中）'
      }else if(duration == 3){
        tips = '码哩码哩哄～(╯°□°）╯︵ ┻━┻（念咒中）'
      }else if(duration == 2){
        tips = '提示用户：共脑中(●--●)'
      }else if(duration == 1){
        tips = '码哩正在读取你的想法(●°u°●)​ 」'
      }else if(duration == 0){
        tips = '码哩正在打开脑电波，接受信号中O(∩_∩)O~'
      }
      console.log('tips',tips);
      EventBus.$emit('llm-tips', tips);
    },
    handleMsg(msg){
      // console.log('msg', msg);
      this.msg = this.replaceLineBreaks(msg)
    },
    replaceLineBreaks(str) {
      return str?str.replace(/\\n/g, '\n').replace(/\n/g, '<br>'):"";
    },
    message(){
      this.$message({
        dangerouslyUseHTMLString: true,
        message: '抱歉，AI忙不过来啦，请您重新生成试试哦，如有其它问题可<a style="color: #0052D9;font-weight: bold;" href="https://work.weixin.qq.com/kfid/kfc73d694476dbadaf1" target="_blank">联系客服</a>',
        type: 'error',
        duration: 8 * 1000
      })
    },
    log(){
      create({predicate: 'BAIDU_TUIGUANG', objectText: 'querystring'});
    },
  }
};
</script>
<style>
.dialog-content {
  /* display: flex; */
  height: 60vh; /* 控制弹窗内容高度 */
  /* position: relative; */
}

.el-select-dropdown {
  z-index: 9001 !important;
}
.main-content {
  flex: 1;
  padding: 20px;
}

.right-panel {
  margin-top: -3rem;
  margin-right: -20vw;
  width: 20vw;
  background: #fff;
  border-left: 1px solid #ebeef5;
  height: calc(100% + 4rem);
  display: flex;
  flex-direction: column;
}

.panel-header {
  padding: 15px;
  border-bottom: 1px solid #ebeef5;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close-btn {
  font-size: 24px;
  padding: 0;
}

.panel-content {
  flex: 1;
  padding: 20px;
  overflow: auto;
}

/* 调整弹窗内边距 */
:deep(.custom-dialog) .el-dialog__body {
  padding: 0;
}
</style>
<style scoped>
.container1 {
  display: flex;
  flex-wrap: wrap; /* 允许换行 */
  gap: 10px; /* 元素间距 */
}

.item1 {
  flex: 1 1 auto; /* 关键属性：自适应伸缩，基础宽度30% */
  min-width: 200px; /* 可选：避免元素过小 */
  box-sizing: border-box; /* 确保边框和内边距不影响宽度计算 */
}
.mly-shadow {
  padding: 25px 32px;
  box-shadow: 2px 2px 10px 0px rgba(54,110,244,0.07);
}
.mly-shadow:hover{
  cursor: pointer;
  box-shadow: 4px 4px 15px 0 rgba(54, 110, 244, .2);
}
/deep/ video {
  mix-blend-mode: screen;
  /* background: #000000; */
  background: transparent;
}
.container {
    width: 100%; /* 或者你想要设置的宽度 */
    height: 400px; /* 或者你想要设置的高度 */
    overflow: hidden;
    position: relative;
    background-image: url('../assets/newer-gift-v2.png');/* 替换为你的图片地址 */
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: bottom center;
}

.stretch {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 50%; /* 或者你想要拉伸的部分的高度 */
  background-image: url('../assets/newer-gift-v2.png');
  background-repeat: repeat-x;
  background-size: 100% auto;
  background-position: bottom center;
}
.frame-player {
    position: absolute;
    width: 768px;
    height: auto;
}
.filter-blur {
  position: absolute;
  top: 0;
  left: 0;
  width: 200px;
  height: 200px;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(10px);
  filter: blur(10px);
  color: #FFFFFF;
  z-index: -1;
}
/* 容器样式 */
.table-container1 {
  display: grid;
  grid-template-rows: repeat(2, 1fr); /* 2行，每行高度相等 */
  grid-auto-flow: column; /* 允许项目填充更小的空格 */
  /* grid-auto-columns: repeat(1, 1fr); */
  gap: 8px; /* 单元格间隙 */
  /* width: auto; */
  overflow-y: hidden;
  overflow-x: auto;
  background: pink;
}

/* 单元格样式 */
.table-cell1 {
  display: flex;
  border: 1px solid #000; /* 边框样式 */
  padding: 8px; /* 单元格内边距 */
  box-sizing: border-box; /* 边框和内边距包含在宽度内 */
  width: 10rem;
}

/* 内容样式，用于调整内容以适应单元格宽度 */
.content {
  width: 100px;
  height: 100px;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(10px);
}


/* png iframe */
.animation-container {
  position: relative;
  width: 100%; /* 根据你的帧尺寸调整 */
  height: 100%; /* 根据你的帧尺寸调整 */
}

.animation-frame {
  width: 100%;
  height: auto;
  display: block;
}

/* 定义关键帧动画 */
@keyframes play-sequence {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

/* 应用动画到图像 */
.animation-frame {
  animation: play-sequence 30ms steps(1) infinite;
}
/* png iframe end */
</style>
